import React from "react";
import { Eye, Target } from "lucide-react";
import { Overline } from "./Shared";
import { useReveal } from "../hooks/useReveal";

export const VisionMission = ({ t }) => {
  const v = t.vision;
  const { ref, visible } = useReveal();

  return (
    <section id="vision" data-testid="vision-section" className="relative py-24 sm:py-32">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/3137050/pexels-photo-3137050.jpeg"
          alt="Vision"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-aa-green/92" />
      </div>

      <div ref={ref} className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
        <div className={`text-center reveal ${visible ? "is-visible" : ""}`}>
          <Overline>{v.overline}</Overline>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-px bg-aa-gold/20 border border-aa-gold/20">
          {[
            { icon: Eye, title: v.visionTitle, text: v.visionText },
            { icon: Target, title: v.missionTitle, text: v.missionText },
          ].map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={i}
                data-testid={`vision-card-${i}`}
                className={`bg-aa-green/80 backdrop-blur-sm p-10 lg:p-14 reveal ${visible ? "is-visible" : ""}`}
                style={{ transitionDelay: `${i * 0.15}s` }}
              >
                <Icon size={36} strokeWidth={1} className="text-aa-gold" />
                <h3 className="font-heading text-2xl sm:text-3xl text-aa-cream mt-6 font-light tracking-tight">
                  {item.title}
                </h3>
                <p className="font-body font-light text-aa-cream/70 mt-5 text-base sm:text-lg leading-relaxed">
                  {item.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
